import $ from 'jquery';
import MembershipUtils from './../../shared/Membership';

export default () => {
    const $ctaElement = $('.crux-call-to-action.overall-score__locked__text');
    MembershipUtils.changeCtaElementText($ctaElement);
    $ctaElement.addClass($ctaElement.text().trim().replace(/\s+/g, '-').toLowerCase());
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/MembershipPageUpdate/pinnedNavCTAUpdate.js